export default "__VITE_ASSET__BtvQllNN__"